import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Download, Shield, FileText } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Authority Section */}
        <div className="bg-slate-800/50 rounded-lg p-6 mb-8 border border-slate-700">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start space-x-3">
              <Shield className="w-6 h-6 text-slate-400 mt-1" />
              <div>
                <h4 className="text-white font-semibold text-sm mb-1">Warranty Backed</h4>
                <p className="text-xs text-slate-400">5-10 year system-specific warranties</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <FileText className="w-6 h-6 text-slate-400 mt-1" />
              <div>
                <h4 className="text-white font-semibold text-sm mb-1">CPWD Compliant</h4>
                <p className="text-xs text-slate-400">IS codes & government standards</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Download className="w-6 h-6 text-slate-400 mt-1" />
              <div>
                <h4 className="text-white font-semibold text-sm mb-1">Company Profile</h4>
                <a 
                  href="/roofsnwalls-brochure.pdf"
                  download="RoofsnWalls_Company_Profile.pdf"
                  className="text-xs text-blue-400 hover:text-blue-300"
                >
                  Download PDF
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/i0gx4r3y_roofsnwalls.png" 
                alt="roofsnwalls" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-4">
              26 years of proven waterproofing excellence. Established 1998. Serving government infrastructure and residential clients across Central India.
            </p>
            <div className="text-xs text-slate-500 space-y-1">
              <p>GST: [Registration Number]</p>
              <p>PAN: [Registration Number]</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/government-projects" className="text-sm hover:text-white transition-colors">
                  Government Projects
                </Link>
              </li>
              <li>
                <Link to="/residential" className="text-sm hover:text-white transition-colors">
                  Residential Projects
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-sm hover:text-white transition-colors">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-sm">Terrace Waterproofing</li>
              <li className="text-sm">Basement Protection</li>
              <li className="text-sm">Bathroom Waterproofing</li>
              <li className="text-sm">External Walls</li>
              <li className="text-sm">Water Tank Sealing</li>
              <li className="text-sm">Infrastructure Projects</li>
              <li className="text-sm">Injection Grouting</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:+917987676517" className="text-sm hover:text-white transition-colors">
                    +91 79876 76517
                  </a>
                  <p className="text-xs text-slate-500">9 AM - 10 PM (Everyday)</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:business-rc171162@gmail.com" className="text-sm hover:text-white transition-colors">
                  business-rc171162@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">1254 Daya Nagar Yadav Colony, Jabalpur, Madhya Pradesh</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Service Areas */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="text-center mb-4">
            <h4 className="text-white font-semibold text-sm mb-2">Service Areas</h4>
            <p className="text-xs text-slate-400">Jabalpur | Bhopal | Indore | Central India</p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-sm text-slate-400">
            © {currentYear} roofsnwalls. All rights reserved. | Est. 1998 | 26 Years of Trusted Service
          </p>
          <p className="text-xs text-slate-500 mt-2">
            Professional Waterproofing Contractors | CPWD Approved | Government & Residential Projects
          </p>
        </div>
      </div>
    </footer>
  );
};